import { House } from 'lucide-react';
import { Modal } from '../../../../../../../UiKit';
import ServiceableStoresComp from '../../../../../Order/ServiceableStores';

export const VerifyAddressServiceability = ({
  openVerifyAddressModal,
  handleVerifyAddressClose,
  orderId,
  updateAddressServiceability,
  showVerifyAddressBtn,
  handleVerifyAddressBtnClick,
}) => {
  return (
    <>
      {showVerifyAddressBtn && (
        <button
          onClick={handleVerifyAddressBtnClick}
          className='tw-text-[14px] tw-text-[#318616] tw-font-medium tw-bg-green-100 hover:tw-transition-none tw-outline tw-outline-[1px] tw-outline-green-300/80 tw-transform tw-transition-all hover:tw-bg-green-200/80 tw-duration-300 tw-ease-in-out tw-rounded-[0.6rem] tw-border-none tw-px-12 tw-py-5 tw-leading-none tw-cursor-pointer tw-mb-6 tw-flex tw-items-center tw-justify-center tw-gap-2'
        >
          <House size={16} strokeWidth={2.2} /> Verify Address
        </button>
      )}

      {openVerifyAddressModal && (
        <Modal
          isVisible={openVerifyAddressModal}
          type='medium'
          title={
            <div className='tw-font-medium tw-text-[20px] tw-text-[#1C1C1C]'>
              Check Store Serviceability
            </div>
          }
          maxHeight='72vh'
          paddingTop='0'
          handleClose={handleVerifyAddressClose}
          padding={0}
          containerStyles={{ margin: '16px 0 20px 0', padding: '0 20px' }}
          component={
            <ServiceableStoresComp
              orderId={orderId}
              updateAddressServiceability={updateAddressServiceability}
            />
          }
        />
      )}
    </>
  );
};
